//this functionality is for the secondary chat button on the corporate gifting page (https://www.tenthousandvillages.com/pages/corporate-gifting)
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function () { 
    var timer = setInterval(function () { 
        var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head'); 
        if (!chatButtonHead?.children.length) { 
            return; 
        } 
        clearInterval(timer); 
 
        var myButton = document.getElementById('chatLive');

        // onClick, behave like a chat opener 
        myButton.onclick = function () { 
            if (GorgiasChat.isOpen()) { 
                GorgiasChat.close(); 
            } else { 
                GorgiasChat.open(); 
            } 
        } 
    }, 50); 
});